import { ErrorManagerCodeEnum } from '@msc-b2c/interfaces/enums';
import { AEMLink } from '@msc-b2c/interfaces/types';
import { setErrorManagerCode, store } from '@msc-b2c/shared-utils';
import { NavigateFunction, NavigateOptions } from 'react-router-dom';
import { navigateOrRedirectToRoute } from '../../navigationmenu/utils/navigationMenuUtils';

const normalizeCode = (code?: string): string => code?.trim().toLowerCase() ?? '';

export const CART_FROM_CHECKOUT_AVAILABILITY_REDIRECT_STATE = 'fromCheckoutAvailabilityRedirect';

export type CartNavigationState = {
  [CART_FROM_CHECKOUT_AVAILABILITY_REDIRECT_STATE]?: boolean;
};

export const isCartAvailabilityErrorCode = (code?: string): boolean => {
  const normalized = normalizeCode(code);
  return (
    normalized === ErrorManagerCodeEnum.ALL_ITEMS_NOT_AVAILABLE ||
    normalized === ErrorManagerCodeEnum.SOME_ITEMS_NOT_AVAILABLE
  );
};

export const redirectToEmptyCartPage = (
  emptyCartRedirectionLink: AEMLink | undefined,
  navigate: NavigateFunction,
  options?: NavigateOptions
): void => {
  if (emptyCartRedirectionLink) {
    navigateOrRedirectToRoute(emptyCartRedirectionLink, navigate, options);
  }
};

/**
 * Sets errorManagerCode (parent Error Manager reads it). Navigates to the cart page only when
 * every item is unavailable; partial availability stays on the current page with reconciled cart.
 * Redux state is shared across cart/checkout because Error Manager lives in the parent container.
 */
export const redirectToCartWithAvailabilityError = (
  issueCode: string,
  emptyCartRedirectionLink: AEMLink | undefined,
  navigate: NavigateFunction
): void => {
  const normalizedCode = normalizeCode(issueCode);
  if (isCartAvailabilityErrorCode(normalizedCode)) {
    store.dispatch(setErrorManagerCode(normalizedCode));
  }
  if (normalizedCode === ErrorManagerCodeEnum.ALL_ITEMS_NOT_AVAILABLE) {
    redirectToEmptyCartPage(emptyCartRedirectionLink, navigate, {
      replace: true,
      state: { [CART_FROM_CHECKOUT_AVAILABILITY_REDIRECT_STATE]: true },
    });
  }
};
